'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.isGMap = isGMap;
exports.isBMap = isBMap;
exports.geocode = geocode;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isGMap(api) {
  return !!api.LatLng;
}

function isBMap(api) {
  return !api.LatLng;
}

var geocoder = void 0;
function geocode(api, data) {
  var addressToLocation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!geocoder) {
    geocoder = new api.Geocoder();
  }
  return new _promise2.default(function (resolve, reject) {
    if (isGMap(api)) {
      if (addressToLocation) {
        geocoder.geocode({ 'address': data }, function (results, status) {
          return status == 'OK' ? resolve([data, results[0]]) : reject();
        });
      } else {
        geocoder.geocode({ 'location': data }, function (results, status) {
          return status == 'OK' ? resolve([results[0].formatted_address, data]) : reject();
        });
      }
    } else {
      if (addressToLocation) {
        geocoder.getPoint(data, function (point) {
          return point ? resolve([data, point]) : reject();
        });
      } else {
        geocoder.getLocation(data, function (location) {
          return location ? resolve([location.address, data]) : reject();
        });
      }
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/shared/mapApi.js
// module id = 96
// module chunks = 0